import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import LampIcon from '~/pages/anatomyV2/quickExperiment/libs/components/AnatomyV2QuickExperiment/LampIcon'
import {
  QUICK_EXPERIMENT_OPTIONS,
  QUICK_EXPERIMENT_QUESTION,
  SECTION_NUMBER,
  quickExperimentIllustrationPNG,
  quickExperimentIllustrationWEBP,
} from '~/pages/anatomyV2/quickExperiment/libs/components/AnatomyV2QuickExperiment/constants'
import { AnatomyV2QuickExperimentStyles as S } from '~/pages/anatomyV2/quickExperiment/libs/components/AnatomyV2QuickExperiment/styles'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const AnatomyV2QuickExperiment = ({ pageId, nextPagePath }: TPageProps) => {
  useMatchHeaderBackground()

  const { t } = useTranslation('anatomyV2')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUICK_EXPERIMENT_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <SectionProgress currentSection={SECTION_NUMBER} pageId={pageId} />

        <S.Title>
          <Trans ns="anatomyV2" i18nKey="onboarding.quickExperiment.title" />
        </S.Title>

        <S.Card>
          <picture>
            <source
              srcSet={quickExperimentIllustrationWEBP}
              type="image/webp"
            />
            <S.Illustration src={quickExperimentIllustrationPNG} alt="" />
          </picture>
          <S.IconWrapper>
            <LampIcon />
          </S.IconWrapper>
          <S.Instruction>
            <Trans
              ns="anatomyV2"
              i18nKey="onboarding.quickExperiment.instruction"
            />
          </S.Instruction>
        </S.Card>

        <S.Options>
          {QUICK_EXPERIMENT_OPTIONS.map(({ key, i18nKey }) => (
            <S.OptionButton
              key={key}
              type="button"
              $isSelected={answer === key}
              disabled={isAnswersDisabled}
              onClick={() => {
                setAnswer(key)
                handleChange(key, handleContinue)
                setIsAnswersDisabled(true)
              }}
            >
              {t(i18nKey)}
            </S.OptionButton>
          ))}
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default AnatomyV2QuickExperiment
